function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Help } from '@procore/core-icons';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';
import { useI18nContext } from '../_hooks/I18n';
import { colors } from '../_styles/colors';
import { getGapOutlineFocus } from '../_styles/mixins';
import { spacing } from '../_styles/spacing';
export var CheckboxTooltip = function CheckboxTooltip(props) {
  var I18n = useI18nContext();
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    role: "tooltip",
    trigger: ['hover', 'focus']
  }, props), /*#__PURE__*/React.createElement(StyledCheckboxTooltipIcon, {
    "aria-label": I18n.t('core.form.field.tooltipHelp'),
    "aria-hidden": false,
    size: "sm",
    tabIndex: 0
  }));
};
var StyledCheckboxTooltipIcon = /*#__PURE__*/styled(Help).withConfig({
  displayName: "StyledCheckboxTooltipIcon",
  componentId: "core-12_15_0__sc-1qa1ncf-0"
})(["margin-left:", "px;color:", ";vertical-align:middle;&:focus-visible{border-radius:50%;", " outline-offset:0;}"], spacing.sm, colors.gray45, getGapOutlineFocus);
//# sourceMappingURL=CheckboxTooltip.js.map